<template>
    <ul class="productPolicy" v-if="details">
    <li>
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="17" viewBox="0 0 23 17">
        <g fill="#231F20" fill-rule="evenodd">
          <path
            d="M8.18 14.666h6.989v-.594h-6.99zM2.581 14.667H0V0h18.895v3.393h-.579V.595H.578v13.477h2.003v.595"
          />
          <path
            d="M4.125 4.441h6.143v-.594H4.125zM10.032 7.818h6.143v-.594h-6.143zM12.394 4.441h3.78v-.594h-3.78zM4.007 7.818h3.78v-.594h-3.78zM22.371 14.948H20.58v-.594h1.214V8.047c0-1.665-1.32-3.02-2.94-3.02h-1.985l.007 1.273v3.785h4.145v.595h-4.723V6.302l-.01-1.869h2.566c1.94 0 3.518 1.621 3.518 3.614v6.901M5.394 12.751c-.786 0-1.425.788-1.425 1.757 0 .97.64 1.758 1.425 1.758.786 0 1.425-.788 1.425-1.758 0-.969-.639-1.757-1.425-1.757zm0 4.109c-1.105 0-2.004-1.055-2.004-2.352s.9-2.352 2.004-2.352 2.003 1.055 2.003 2.352-.899 2.352-2.003 2.352z"
          />
          <path
            d="M17.906 12.751c-.786 0-1.424.788-1.424 1.757 0 .97.638 1.758 1.424 1.758.786 0 1.425-.788 1.425-1.758 0-.969-.64-1.757-1.425-1.757zm0 4.109c-1.104 0-2.004-1.055-2.004-2.352s.9-2.352 2.004-2.352c1.105 0 2.004 1.055 2.004 2.352s-.899 2.352-2.004 2.352z"
          />
        </g>
      </svg>
      {{$t('delivary')}}
    </li>
    <li v-if="details.codEnabled">
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 21 23">
        <g fill="#231F20" fill-rule="evenodd">
          <path
            d="M16.843 22.951H.393V9.067h16.45v4.271h-.579V9.661H.972v12.696h15.292v-3.759h.579v4.353"
          />
          <path
            d="M12.27 14.607c-1.026 0-1.861.629-1.861 1.402 0 .773.835 1.402 1.861 1.402h5.924v-2.804H12.27zm6.504 3.398H12.27c-1.345 0-2.44-.895-2.44-1.996s1.095-1.996 2.44-1.996h6.504v3.992zM14.754 9.561l-.173-.567 5.076-1.635-2.02-6.614L.724 6.192l.923 3.024-.552.178L0 5.803 18.015 0l2.367 7.748-5.628 1.813"
          />
          <path
            d="M3.096 9.363a1.66 1.66 0 0 1 .001-1.512 1.59 1.59 0 0 1 .933-.802c.836-.269 1.73.211 1.992 1.069.122.399.092.825-.085 1.2l-.521-.259c.113-.239.132-.51.054-.763a1.007 1.007 0 0 0-1.267-.68 1.012 1.012 0 0 0-.594.51 1.06 1.06 0 0 0 .001.963l-.514.274M15.88 3.904a1.01 1.01 0 0 0-.897.558 1.06 1.06 0 0 0-.067.792c.132.435.52.728.964.728a1.012 1.012 0 0 0 .897-.558 1.06 1.06 0 0 0 .068-.792 1.011 1.011 0 0 0-.964-.728zm0 2.672c-.698 0-1.308-.46-1.516-1.144a1.66 1.66 0 0 1 .107-1.245 1.592 1.592 0 0 1 1.41-.877c.698 0 1.306.46 1.516 1.144a1.66 1.66 0 0 1-.108 1.245 1.59 1.59 0 0 1-1.41.877zM10.892 9.679l-.142-.576c.046-.012.093-.026.14-.041a1.926 1.926 0 0 0 1.227-1.152c.222-.551.235-1.209.04-1.852-.405-1.321-1.475-1.952-2.665-1.569a1.993 1.993 0 0 0-1.255 1.157c-.234.555-.256 1.211-.062 1.847.245.802.778 1.383 1.462 1.594l-.167.569c-.87-.268-1.543-.992-1.847-1.985-.236-.773-.206-1.576.083-2.261a2.598 2.598 0 0 1 1.613-1.488c1.497-.482 2.89.323 3.39 1.958.236.776.217 1.577-.057 2.256a2.526 2.526 0 0 1-1.76 1.543M12.404 16.725h.578v-1.542h-.578zM4.757 12.029h1.466v-.594H4.757v.594zm2.931 0h1.467v-.594H7.688v.594zm2.932 0h1.465v-.594H10.62v.594zM13.55 12.029h.859v-.594h-.858z"
          />
        </g>
      </svg>
      {{$t('paymentViaCash')}}
    </li>
    <li>
      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="17" viewBox="0 0 27 17">
        <g fill="none" fill-rule="evenodd">
          <path
            stroke="#231F20"
            stroke-width=".594"
            d="M17.505 16.628H1.977A.99.99 0 0 1 1 15.625V7.699a.99.99 0 0 1 .977-1.003h15.528a.99.99 0 0 1 .977 1.003v7.926a.99.99 0 0 1-.977 1.003z"
          />
          <path fill="#FFF" d="M1.186 11.757h11.02V9.322H1.185z" />
          <path stroke="#231F20" stroke-width=".594" d="M1.186 11.757h11.02V9.322H1.185z" />
          <path
            fill="#231F20"
            d="M13.6 10.837h3.417v-.594H13.6zM3.185 14.466h3.418v-.595H3.185zM8.578 14.466h7.578v-.595H8.578zM25.13 10.527l-6.304-.087.008-.594 6.3.086a.696.696 0 0 0 .682-.705V1.3a.696.696 0 0 0-.686-.705H9.602a.697.697 0 0 0-.688.705v4.441h-.578V1.3c0-.716.567-1.3 1.266-1.3H25.13c.697 0 1.266.584 1.266 1.3v7.927c0 .716-.569 1.3-1.266 1.3"
          />
          <path fill="#FFF" d="M8.81 5.144h11.02v-2.22H8.81z" />
          <path stroke="#231F20" stroke-width=".594" d="M8.81 5.144h11.02v-2.22H8.81z" />
          <path
            fill="#231F20"
            d="M23.172 4.438h3.416v-.594h-3.416zM19.365 8.067h4.416v-.594h-4.416z"
          />
          <path
            fill="#FFF"
            d="M18.935 10.684l-.02-4.028c-.006-.132-.371-.5-.613-.545l-10.194.016-.001-.594 10.235-.017.02.003c.471.063 1.13.646 1.131 1.133l.022 4.029-.58.003"
          />
        </g>
      </svg>
      {{$t('paymentOnline')}}
    </li>

    <li v-if="details.eligibleforReturn">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
        <g fill="none" fill-rule="evenodd">
          <path
            fill="#231F20"
            d="M18.302 13.547l.372.218c.063.035.228.095.326.048.081-.038.128-.162.151-.256-.017-.081-.063-.205-.139-.247-.093-.052-.257.014-.346.058l-.364.179zm-4.03 9.684c-.95.001-1.823-1.044-2.133-1.46-1.798.385-3.34-.028-3.888-.209-1.419 1.836-2.555 1.254-2.604 1.227-1.265-.679-.856-2.615-.694-3.217-1.23-1.306-1.75-2.387-1.94-2.873-.764.167-1.416.072-1.94-.282-.9-.608-1.063-1.754-1.07-1.803L0 14.574v-1.813l.007-.031c.182-.874.572-1.495 1.16-1.845.632-.377 1.325-.333 1.703-.267a7.502 7.502 0 0 1 1.205-2.269c-.217-1.429-.087-2.498.39-3.181.372-.535.82-.624.87-.632 1.05-.185 1.797.915 2.03 1.314l.211.029-.078.589-.501-.07-.07-.138c-.005-.012-.66-1.285-1.497-1.138-.01.002-1.25.297-.763 3.265l.023.141-.093.107c-.008.01-.857.995-1.25 2.415l-.082.295-.285-.093c-.007-.003-.84-.262-1.526.149-.433.26-.727.738-.875 1.423v1.726c.022.127.186.951.815 1.373.438.293 1.018.339 1.726.138l.278-.08.078.286c.003.013.383 1.33 2.009 3.014l.125.13-.056.173c-.007.021-.677 2.122.362 2.679.028.013.84.378 2.001-1.229l.132-.184.207.085c.017.007 1.838.726 3.937.215l.194-.048.112.169c.32.478 1.313 1.645 2.07 1.299.04-.019.925-.457.415-2.423l-.054-.209.178-.118c.027-.018 2.797-1.906 3.135-5.823l.037-.439-.03.015.002-.474c0-.033-.03-3.365-2.596-5.532l-.066-.05.102-.081.16-.171.14-.181C18.26 9 18.728 11.7 18.81 12.704a.749.749 0 0 1 .483.087c.373.213.435.688.44.742l.005.046-.01.046c-.09.457-.318.65-.49.73a.807.807 0 0 1-.459.06c-.428 3.445-2.557 5.301-3.187 5.781.526 2.33-.741 2.896-.797 2.92-.175.08-.351.115-.525.115z"
          />
          <path
            fill="#3E3D48"
            d="M4.91 11.097c0 .27-.213.489-.477.489a.483.483 0 0 1-.476-.489c0-.27.213-.489.476-.489.264 0 .477.219.477.489"
          />
          <path
            stroke="#231F20"
            stroke-width=".594"
            d="M15.62 4.813c0 2.106-1.662 3.814-3.714 3.814-2.05 0-3.712-1.708-3.712-3.814S9.856 1 11.906 1c2.052 0 3.714 1.707 3.714 3.813z"
          />
          <path
            fill="#000"
            fill-rule="nonzero"
            d="M12.574 4.046h-.427c-.025-.326-.152-.628-.338-.814h.765c.046 0 .084-.052.084-.116S12.62 3 12.574 3h-1.78c-.046 0-.083.052-.083.116s.037.116.084.116h.51c.346 0 .631.36.673.814h-1.183c-.047 0-.084.052-.084.116s.037.116.084.116h1.183c-.042.47-.332.823-.674.825h-.509c-.047 0-.084.054-.084.12 0 .03.01.06.026.083l1.273 1.662c.033.044.086.042.118-.004a.153.153 0 0 0-.003-.166l-1.12-1.463h.298c.44 0 .802-.465.844-1.057h.427c.046 0 .084-.052.084-.116s-.038-.116-.084-.116z"
          />
        </g>
      </svg>
      {{details.returnMessage}}
    </li>
  </ul>
</template>

<script>
import { bus } from "../../../main";
export default {
  name: "ProductPolicy",
    props: {
    productPolicy: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      details:{}
    };
  },
  watch:{
productPolicy(){
  this.details=this.productPolicy;
}
  },
  methods: {
    showToast(type) {
      if (type === "Delivary") {
        this.emitToaster(this.$t('delivary'))
      } else if (type === "Free") {
          this.emitToaster(this.$t('freeShippingMsg'))
      } else if (type === "Refund") {
        this.emitToaster(this.details.returnMessage);
      }
    },
    emitToaster(status){
            let obj = {
                status: status,
                timeoutMs: "5000",
                color:'Green'
              };
              bus.$emit("apiStatus", obj);
    }
  },
  mounted() {
      this.details=this.productPolicy;
  }
};
</script>
    